export const FETCH_DL_TABLES = "FETCH_DL_TABLES";
export const FETCH_DL_TABLES_SUCCESS = "FETCH_DL_TABLES_SUCCESS";
export const FETCH_DL_TABLES_FAILED = "FETCH_DL_TABLES_FAILED";
